export enum OrderType {
    Asc = 'ASC',
    Desc = 'DESC'
}
